import * as z from 'zod';

// Validation messages are translation keys (resolved via t() at render time in
// TimesheetTaskFormDialog's form resolver), matching the hr-department-manager
// zod schema pattern -- not translated inline here.
const hourValue = z
  .number({ invalid_type_error: 'MY_TIMESHEET_HOURS_REQUIRED' })
  .min(0, { message: 'MY_TIMESHEET_HOURS_POSITIVE' })
  .max(24, { message: 'MY_TIMESHEET_HOURS_MAX_24' });

const timesheetTaskRowSchema = z.object({
  MbmProjectId: z.string().min(1, { message: 'MY_TIMESHEET_PROJECT_REQUIRED' }),
  Billable: hourValue,
  GeneralAdmin: hourValue,
  SalesAndMarketing: hourValue,
});

// Mirrors the Angular source's `_totalTimeValidator` (AddTimesheetTaskDialogComponent),
// which rejects a day's tasks once their combined seconds reach 24h.
export const timesheetTaskFormSchema = z
  .object({
    TaskDate: z.string().min(1, { message: 'MY_TIMESHEET_DATE_REQUIRED' }),
    Tasks: z.array(timesheetTaskRowSchema).min(1, { message: 'MY_TIMESHEET_AT_LEAST_ONE_TASK_REQUIRED' }).max(5, {
      message: 'MY_TIMESHEET_MAX_TASKS_ALLOWED',
    }),
  })
  .refine(
    (values) =>
      values.Tasks.reduce((sum, task) => sum + task.Billable + task.GeneralAdmin + task.SalesAndMarketing, 0) <= 24,
    { message: 'MY_TIMESHEET_TOTAL_HOURS_EXCEEDED', path: ['Tasks'] }
  );

export type TimesheetTaskFormValues = z.infer<typeof timesheetTaskFormSchema>;
